import React from "react";

import Icon from "../Icon";
import { createUseStyles } from "react-jss";

import { UIHeading, UIText } from "../ui/UIElements";

const TotalCard = ({ totalNo, totalTxt, iconName }) => {
  const styles = useStyles();
  return (
    <div className={`${styles.totalcard} ${styles.boxShadow}`}>

      <div className={styles.titdiv}>
        <UIText type="secondary" style={{ margin: 0 }} level={5}>
          {totalTxt}
        </UIText>
        <UIHeading level={4} style={{ margin: 0 }}>
          {totalNo ? totalNo : "-"}
        </UIHeading>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  totalcard: {
  
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  boxShadow: {
    background: "#fff",
    boxShadow:  '6px 6px 33px #e9e9e9'
  },
  titdiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  idiv: {
    background: "#ebf1f7",
    padding: 8,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default TotalCard;
